<script>
    import { executeClient } from 'api/rage'

    export let viewData;
    let data = typeof viewData === 'string' ? JSON.parse(viewData) : viewData;
    let maxDays = data.maxDays || 7;
    let taxDays = 1;
    $: if (taxDays > maxDays) taxDays = maxDays;
    $: if (taxDays < 1) taxDays = 1;

    function payTax() {
        if (taxDays < 1 || taxDays > maxDays) return;
        executeClient('warehouse', 'payTax', JSON.stringify({ unitId: data.unitId, days: taxDays }));
    }

    function close() {
        executeClient('warehouse', 'close', '{}');
    }

    function fmt(n) {
        if (!n) return '0';
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function handleKey(e) {
        if (e.key === 'Escape') close();
    }
</script>

<svelte:window on:keydown={handleKey} />

<div class="overlay">
    <div class="panel">
        <div class="header-row">
            <div class="title">Оплата налога склада</div>
            <div class="close-btn" on:click={close}>
                <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.999268 0.999756L4.99927 4.99976M8.99927 8.99976L4.99927 4.99976M4.99927 4.99976L8.99927 0.999756L0.999268 8.99976" stroke="#949494" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        <div class="sep"></div>
        <div class="info-row">
            <span class="label">Оплачено до:</span>
            <span class="value">{data.paidUntil}</span>
        </div>
        <div class="info-row">
            <span class="label">Стоимость:</span>
            <span class="value green">${fmt(data.taxPerDay)} / день</span>
        </div>
        {#if maxDays <= 0}
        <div class="max-notice">Налог уже оплачен на максимум (7 дней)</div>
        {:else}
        <div class="days-section">
            <div class="days-label">Выберите количество дней (макс. {maxDays}):</div>
            <div class="days-grid">
                {#each Array.from({length: maxDays}, (_, i) => i + 1) as d}
                    <div class="day-btn" class:active={taxDays === d} on:click={() => taxDays = d}>{d}</div>
                {/each}
            </div>
        </div>
        <div class="total-row">
            <span class="label">Итого:</span>
            <span class="total-val">${fmt(data.taxPerDay * taxDays)}</span>
        </div>
        <div class="btns">
            <div class="btn pay" on:click={payTax}>Оплатить</div>
            <div class="btn cancel" on:click={close}>Отмена</div>
        </div>
        {/if}
    </div>
</div>

<style>
    *{box-sizing:border-box;margin:0;padding:0}
    .overlay{
        position:fixed;inset:0;
        display:flex;align-items:center;justify-content:center;
        z-index:5000;
        font-family:'Inter','Segoe UI',sans-serif;
        background:rgba(0,0,0,0.5);
    }
    .panel{
        background:#1a1a1a;
        border-radius:12px;
        width:460px;
        color:#fff;
        padding:0;
        overflow:hidden;
        border:1px solid rgba(255,255,255,0.08);
    }
    .header-row{
        display:flex;align-items:center;justify-content:space-between;
        padding:18px 20px 16px;
    }
    .title{font-size:18px;font-weight:700}
    .close-btn{
        cursor:pointer;
        width:28px;height:28px;
        display:flex;align-items:center;justify-content:center;
        border-radius:6px;
        background:rgba(255,255,255,0.06);
    }
    .close-btn:hover{background:rgba(255,255,255,0.12)}
    .sep{height:1px;background:rgba(255,255,255,0.08)}
    .info-row{
        display:flex;justify-content:space-between;align-items:center;
        padding:10px 20px;
        font-size:14px;
    }
    .label{color:#888}
    .value{color:#fff;font-weight:500}
    .value.green{color:#CDF15C;font-weight:600}
    .days-section{padding:14px 20px 0}
    .days-label{font-size:13px;color:#888;margin-bottom:10px}
    .days-grid{display:flex;gap:8px;flex-wrap:wrap}
    .day-btn{
        width:44px;height:44px;
        border-radius:8px;
        background:#2a2a2a;
        color:#aaa;
        display:flex;align-items:center;justify-content:center;
        cursor:pointer;
        font-size:16px;font-weight:700;
        border:2px solid transparent;
        transition:all 0.15s;
    }
    .day-btn:hover{background:#333;color:#fff}
    .day-btn.active{background:#c2185b;color:#fff;border-color:#e91e63}
    .total-row{
        display:flex;justify-content:space-between;align-items:center;
        padding:14px 20px;
        font-size:14px;
    }
    .total-val{font-size:22px;font-weight:800;color:#CDF15C}
    .max-notice{
        padding:20px;
        text-align:center;
        color:#888;
        font-size:14px;
    }
    .btns{
        display:flex;gap:10px;
        padding:0 20px 20px;
    }
    .btn{
        flex:1;padding:13px;
        border-radius:8px;
        font-size:15px;font-weight:600;
        cursor:pointer;text-align:center;
        transition:background 0.15s;
    }
    .btn.pay{background:#2e7d32;color:#fff}
    .btn.pay:hover{background:#388e3c}
    .btn.cancel{background:#2a2a2a;color:#777}
    .btn.cancel:hover{color:#bbb}
</style>